import { Allocation } from "@/types/allocations.types";
import { ApiResponse } from "@/types/api.types";
import axios from "axios";
import {
  onReqFulfilled,
  onReqRejected,
  onResFulfilled,
  onResRejected,
} from "./helpers";

const teacherAPI = axios.create({
  baseURL: `${process.env.REACT_APP_OLD_API_BASEURL}`,
});

teacherAPI.interceptors.request.use(onReqFulfilled, onReqRejected);
teacherAPI.interceptors.response.use(onResFulfilled, onResRejected);

export const getSubjectAllocations = (params): Promise<ApiResponse<Allocation[]>> => teacherAPI.get("", { params: { action: "get_teacher_subject_allocations", ...params } });